import Action from "public@action/index";
import { store } from "public@store/index";
import sdk from "global@public/sdk";
import { leanSendMsg } from "pc@root/handle/message";
import { message } from "antd";
import voteDialog from "../component/vote";
import { handlerType } from "public@tool/handler";
import Fingerprint2 from "fingerprintjs2";
import verifyDialog from "../component/verify/verify";
import { IInitInfo } from "global@public/type/index";
import { handlerStartEndTim } from "global@public/tool/handler";
import { connectLeanCloud } from "pc@root/handle/message";
import { getQueryString } from "public@tool/getQuery";
const errorInfo = {
  NEED_PWD: "密码错误",
  NEED_INVITIATION_CODE: "邀请码错误",
  XIAOYU_DEVICE_NOT_FOUND: "小鱼设备找不到"
};

let FOUNDAUDIENCECOUNDT = 0;
let FOUNDINIT = true;
class PcAction extends Action {
  public getInitData = async (liveId: string) => {
    const data: any = await sdk.getInitData(liveId);
    if (!!data.code && data.code === 401) {
      window.location.href = data.link;
    }
    this.initInfo(data, liveId);
    document.title = store.liveInfo.title;
    return true;
  };

  public initInfo = (init: IInitInfo, liveId: string) => {
    store.liveId = liveId;
    store.initData = init;
    store.liveInfo = init.bsInfo;
    store.liveStatus = init.bsInfo.status;
    store.needPay = init.needPay;
    store.feeAmount = init.cdInfo.feeAmount;
    store.allow = !init.forbidAll;
    store._loading = false;
    store.handleColumnList();
    store.liveTime = handlerStartEndTim(init.bsInfo.timeStart, init.bsInfo.timeEnd);
    store.inputWatcherInfoType = init.cdInfo.inputWatcherInfoType.map((e: any) => {
      return e.toLowerCase();
    });

    if (init.preside && !init.isVerification) {
      this.putAudience(store.liveId);
      return;
    } else if (init.preside && init.isVerification) {
      this.getAudience(store.liveId);
      return;
    }

    if (init.isVerification && !init.viewerExist) {
      store.isVerification = true;
      this.showVoteDialog();
    }

    if (!init.needPay) {
      if (init.viewerExist) {
        this.getAudience(store.liveId);
      } else if (!store.isVerification) {
        this.putAudience(store.liveId);
      }
    } else {
      store.isFeeLive = false;
    }
  };

  public showVoteDialog = () => {
    verifyDialog.verify();
  };

  public confirmVote = async (target: any, voteId: string) => {
    this.getConfirmVote(voteId);
  };

  public getConfirmVote = async (voteId: string) => {
    const { data } = await sdk.getVoteInfo(voteId);
    if (localStorage[voteId]) {
      if (data.open) {
        this.resultVote(voteId);
      } else if (data.status !== "NORMAL") {
        voteDialog.voteReminder(data);
      } else {
        voteDialog.voteRepetition();
      }
    } else {
      voteDialog.voteSelect(data, this.submitVote);
    }
  };

  public submitVote = async (target: any, param: any) => {
    const { data } = await sdk.postSubmitVote(param);
    localStorage.setItem(param.questionnaireId, store.liveId);
    if (data.open) {
      voteDialog.voteResult(data);
    } else {
      voteDialog.hideDialog();
      message.info("投票成功");
    }
  };

  public resultVote = async (voteId: string) => {
    const { data } = await sdk.resultVote(voteId);
    voteDialog.voteResult(data);
  };

  public onMessageSend = () => {
    const { messageValue, allow } = store;

    if (!allow) {
      message.info("禁止发言");
      return;
    }

    if (!store.sendMsgState) {
      if (messageValue.trim() === "") {
        message.info("发送信息不能为空");
        return;
      }
      store.sendMsgState = true;
      leanSendMsg(messageValue);
    } else {
      let sTime:any;
      message.info("请不要重复发送");
      clearTimeout(sTime);
      sTime = setTimeout(() => {
        store.sendMsgState = false;
      }, 1000)
    }
  };

  public getAudience = async (liveId: string) => {
    const BType = handlerType();
    const type = BType === "hls" ? "m3u8" : BType;
    const GEData = await sdk.getAudience(liveId, type, store.randomStr);

    if (FOUNDINIT) {
      FOUNDINIT = false;
      setInterval(() => {
        this.getHeartbeat();
      }, 30000);
    }

    if (!!GEData.err && GEData.err.response.data.message.info === "NO_AUDIENCE") {
      if (FOUNDAUDIENCECOUNDT < 5) {
        FOUNDAUDIENCECOUNDT += 1;
        this.putAudience(liveId);
      }
    } else {
      store.disposeChatPlay(GEData);
      if (!!GEData.chatRoomId) {
        connectLeanCloud();
      } else {
        message.info("未拥有聊天室房间号，请刷新后重试");
        sdk.postNotChatRoomIdError();
      }
    }
  };
  public putAudience = async (liveId: string, fn?: () => void) => {
    const { putInfo } = store;
    // @ts-ignore
    Fingerprint2.getV18(
      {
        NOT_AVAILABLE: "not available",
        ERROR: "error",
        EXCLUDED: "excluded"
      },
      async (fingerPrint2Id: any, components: any) => {
        let data = {
          liveId,
          fingerPrint2Id
        };

        if (Object.keys(putInfo).length !== 0) {
          data = Object.assign(data, putInfo);
        }
        const name = getQueryString("name");
        if (!!name) {
          // 安卓decodeURIComponent 两次
          const deCodeUrlName = decodeURIComponent(decodeURIComponent(name));
          data = Object.assign(data, { name: deCodeUrlName });
        }

        const PAData: any = await sdk.putAudience(liveId, data);
        if (!!PAData.errCode) {
          this.errorRemind(PAData.info);
          return;
        }
        store.setUserInfo(PAData);

        // 1. 付费
        if (store.needPay) {
          store.isFeeLive = false;
        } else {
          store.isFeeLive = true;
          await this.getAudience(liveId);
        }

        if (fn) {
          fn();
        }
      }
    );
  };

  public errorRemind = (info: string) => {
    message.info(errorInfo[info]);
  };

  public getHeartbeat = async () => {
    const { liveId, randomStr, liveStatus, onChangeLiveState, praiseCount } = store;
    const BType = handlerType();
    const type = BType === "hls" ? "m3u8" : BType;
    const data = await sdk.getHeartbeat(liveId, type, randomStr, praiseCount);
    store.praiseCount = 0;
    if (
      (liveStatus === "LIVING" && data.status !== "LIVING") ||
      data.status === "session-error" ||
      !!data.kicked
    ) {
      location.reload();
    } else if (liveStatus !== data.status) {
      onChangeLiveState(data.status, data);
    }
  };

  public onSubmitInfo = (target: any) => {
    const { userInputValues, inputWatcherInfoType, liveId } = store;
    store.inputVerify = true;
    const putInfo: any = {};
    inputWatcherInfoType.map((e: any) => {
      this.submitInfoVerify(e);
      if (e === "mobile") {
        putInfo.phone = userInputValues[e];
      } else {
        putInfo[e] = userInputValues[e];
      }
    });
    store.putInfo = putInfo;
    if (store.inputVerify) {
      this.putAudience(liveId, () => {
        target.hide();
      });
    }
  };
}

const action = new PcAction(store);

export { action };



// WEBPACK FOOTER //
// ./src/pc/action/index.ts